/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Selfserv Unauth Ext Api
 * Openapi v1 integration spec for Selfserv unauth API Gateway
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import { baseurlv2HttpRequest, unauthHttpRequest } from '../../../../service';
/**
 * Any API where this trait is applied, indicates that application name will be sent in the header as a mandatory attribute. This trait describes the name of the application from where the request is being sent.
 * @summary This API registers the customer for the given user profile.
 */
export const register = (registerRequestBodyBody, signal) => {
    return baseurlv2HttpRequest({ url: `/customers/register`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: registerRequestBodyBody, signal
    });
};
export const getRegisterMutationOptions = (options) => {
    const mutationKey = ['register'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return register(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary This API registers the customer for the given user profile.
*/
export const useRegister = (options, queryClient) => {
    return useMutation(getRegisterMutationOptions(options), queryClient);
};
/**
* Any API where this trait is applied, indicates that application name will be sent in the header as a mandatory attribute. This trait describes the name of the application from where the request is being sent.
* @summary This API triggers the MFA for two or more piece of evidence to verify identity through sms or email.
*/
export const triggerMFAPost = (triggerMFARequestBodyBody, signal) => {
    return unauthHttpRequest({ url: `/customers/trigger-mfa`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: triggerMFARequestBodyBody, signal
    });
};
export const getTriggerMFAPostMutationOptions = (options) => {
    const mutationKey = ['triggerMFAPost'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return triggerMFAPost(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary This API triggers the MFA for two or more piece of evidence to verify identity through sms or email.
*/
export const useTriggerMFAPost = (options, queryClient) => {
    return useMutation(getTriggerMFAPostMutationOptions(options), queryClient);
};
/**
* Any API where this trait is applied, indicates that application name will be sent in the header as a mandatory attribute. This trait describes the name of the application from where the request is being sent.
* @summary This API validates the MFA-code which would be send by an sms or Email.
*/
export const validateMFAPost = (validateMFARequestBodyBody, signal) => {
    return unauthHttpRequest({ url: `/customers/validate-mfa`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: validateMFARequestBodyBody, signal
    });
};
export const getValidateMFAPostMutationOptions = (options) => {
    const mutationKey = ['validateMFAPost'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return validateMFAPost(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary This API validates the MFA-code which would be send by an sms or Email.
*/
export const useValidateMFAPost = (options, queryClient) => {
    return useMutation(getValidateMFAPostMutationOptions(options), queryClient);
};
/**
* This API offers flexibility to caller application to specify scope of OKTA Token, which can be determined by passing client_scope_identifier in the header. client_scope_identifier represent caller client such as Web or Mobile.
* @summary This API generates OKTA Token to support UnAuthenticated usecases.
*/
export const token = (signal) => {
    return unauthHttpRequest({ url: `/customers/token`, method: 'GET', signal
    });
};
export const getTokenQueryKey = () => {
    return [
        `/customers/token`
    ];
};
export const getTokenQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getTokenQueryKey();
    const queryFn = ({ signal }) => token(signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary This API generates OKTA Token to support UnAuthenticated usecases.
 */
export function useToken(options, queryClient) {
    const queryOptions = getTokenQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return { ...query, queryKey: queryOptions.queryKey };
}
export const getCustomersConfig = (params, signal) => {
    return unauthHttpRequest({ url: `/customers/config`, method: 'GET',
        params, signal
    });
};
export const getGetCustomersConfigQueryKey = (params) => {
    return [
        `/customers/config`, ...(params ? [params] : [])
    ];
};
export const getGetCustomersConfigQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCustomersConfigQueryKey(params);
    const queryFn = ({ signal }) => getCustomersConfig(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetCustomersConfig(params, options, queryClient) {
    const queryOptions = getGetCustomersConfigQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return { ...query, queryKey: queryOptions.queryKey };
}
/**
 * Any API where this trait is applied, indicates that application name will be sent in the header as a mandatory attribute. This trait describes the name of the application from where the request is being sent.
 * @summary This API resets the password of a specific user based on ssn and username.
 */
export const resetPasswordPost = (resetPassworRequestBodyBody, signal) => {
    return unauthHttpRequest({ url: `/customers/reset-password`, method: 'PUT',
        headers: { 'Content-Type': 'application/json', },
        data: resetPassworRequestBodyBody, signal
    });
};
export const getResetPasswordPostMutationOptions = (options) => {
    const mutationKey = ['resetPasswordPost'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return resetPasswordPost(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary This API resets the password of a specific user based on ssn and username.
*/
export const useResetPasswordPost = (options, queryClient) => {
    return useMutation(getResetPasswordPostMutationOptions(options), queryClient);
};
/**
* Any API where this trait is applied, indicates that application name will be sent in the header as a mandatory attribute. This trait describes the name of the application from where the request is being sent.
* @summary This API recovers the password of a specific user based on ssn and username.
*/
export const recoverPasswordPost = (recoverPassworRequestBodyBody, signal) => {
    return unauthHttpRequest({ url: `/customers/recover-password`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: recoverPassworRequestBodyBody, signal
    });
};
export const getRecoverPasswordPostMutationOptions = (options) => {
    const mutationKey = ['recoverPasswordPost'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return recoverPasswordPost(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary This API recovers the password of a specific user based on ssn and username.
*/
export const useRecoverPasswordPost = (options, queryClient) => {
    return useMutation(getRecoverPasswordPostMutationOptions(options), queryClient);
};
/**
* Any API where this trait is applied, indicates that application name will be sent in the header as a mandatory attribute. This trait describes the name of the application from where the request is being sent.
* @summary This API recovers the username of a specific user based on ssn and username.
*/
export const recoverUserNamePost = (recoverUserNameRequestBodyBody, signal) => {
    return unauthHttpRequest({ url: `/customers/recover-username`, method: 'POST',
        headers: { 'Content-Type': 'application/json', },
        data: recoverUserNameRequestBodyBody, signal
    });
};
export const getRecoverUserNamePostMutationOptions = (options) => {
    const mutationKey = ['recoverUserNamePost'];
    const { mutation: mutationOptions } = options ?
        options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
            options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey, } };
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return recoverUserNamePost(data);
    };
    return { mutationFn, ...mutationOptions };
};
/**
* @summary This API recovers the username of a specific user based on ssn and username.
*/
export const useRecoverUserNamePost = (options, queryClient) => {
    return useMutation(getRecoverUserNamePostMutationOptions(options), queryClient);
};
/**
* This API returns maintenance banners for the site.
* @summary This API returns maintenance banners for the site.
*/
export const maintenanceBanner = (params, signal) => {
    return unauthHttpRequest({ url: `/maintenance-banner`, method: 'GET',
        params, signal
    });
};
export const getMaintenanceBannerQueryKey = (params) => {
    return [
        `/maintenance-banner`, ...(params ? [params] : [])
    ];
};
export const getMaintenanceBannerQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getMaintenanceBannerQueryKey(params);
    const queryFn = ({ signal }) => maintenanceBanner(params, signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary This API returns maintenance banners for the site.
 */
export function useMaintenanceBanner(params, options, queryClient) {
    const queryOptions = getMaintenanceBannerQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return { ...query, queryKey: queryOptions.queryKey };
}
/**
 * This API returns maintenance banner server time for the site.
 * @summary This API returns maintenance banner server time for the site.
 */
export const maintenanceBannerServerTime = (signal) => {
    return unauthHttpRequest({ url: `/servertime`, method: 'GET', signal
    });
};
export const getMaintenanceBannerServerTimeQueryKey = () => {
    return [
        `/servertime`
    ];
};
export const getMaintenanceBannerServerTimeQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getMaintenanceBannerServerTimeQueryKey();
    const queryFn = ({ signal }) => maintenanceBannerServerTime(signal);
    return { queryKey, queryFn, ...queryOptions };
};
/**
 * @summary This API returns maintenance banner server time for the site.
 */
export function useMaintenanceBannerServerTime(options, queryClient) {
    const queryOptions = getMaintenanceBannerServerTimeQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return { ...query, queryKey: queryOptions.queryKey };
}
export const getCustomersProfile = (signal) => {
    return unauthHttpRequest({ url: `/customers/profile`, method: 'GET', signal
    });
};
export const getGetCustomersProfileQueryKey = () => {
    return [
        `/customers/profile`
    ];
};
export const getGetCustomersProfileQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCustomersProfileQueryKey();
    const queryFn = ({ signal }) => getCustomersProfile(signal);
    return { queryKey, queryFn, ...queryOptions };
};
export function useGetCustomersProfile(options, queryClient) {
    const queryOptions = getGetCustomersProfileQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return { ...query, queryKey: queryOptions.queryKey };
}
//# sourceMappingURL=customer.js.map